import { TabProxy } from "encampy";

// Long enough for the user to complete login + MFA by hand if RCRAInfo redirected to login.gov.
const DRAFTS_PAGE_TIMEOUT_MS = 5 * 60_000;

export async function findManifestInRcraInfo(tab: TabProxy, mtn: string): Promise<void> {
  await tab.waitForElement("#receivedMtnFilter", { timeout: DRAFTS_PAGE_TIMEOUT_MS });
  await tab.type("#receivedMtnFilter", mtn, { typeDelay: 60 });
  // Wait for the server-side data table to re-query and re-render.
  await tab.wait({ duration: 2000 });
  await tab.clickContaining('a[title="View"]', mtn, "tr");
}
